import React, { Fragment } from 'react';
import { useSelector } from 'react-redux';
import Select from 'react-select';
import PropTypes from 'prop-types';
import style, { DROPDOWN_COLORS } from '../themeSupport';

export const DEFAULT_ALL_FILTER_VALUE = { label: 'ALL', value: '', sortName: '!ALL' };

/*
 * NOTE: This Implementation of FilterSelect is intended to replace the current FilterSelect.  There are a number of advantages to this
 * one including being simpler and no longer having fetch logic embedded herein. This is presentational only.  There are intended to be
 * several specific users of this -- of which currently only PortfolioFilter and DateViewFilter are implemented and being used.
 * Other specific filter users (AsinFilter, BrandFilter, CategoryFilter) are implemented and awaiting further movement that requires
 * manual data configuration.
 */

export default function FilterSelect({
  onChange, label, name, options, selected, disable, multi, selectClass,
}) {
  const { theme } = useSelector(state => state);
  const themeColors = style(theme, DROPDOWN_COLORS);

  return (
    <Fragment>
      {label && (<p style={{ whiteSpace: 'nowrap', paddingTop: '10px' }}>{label}</p>)}
      <div className={selectClass}>
        <Select
          value={selected}
          name={name}
          onChange={onChange}
          options={options}
          theme={selectTheme => ({
            ...selectTheme,
            colors: {
              ...selectTheme.colors,
              primary: `${themeColors.colorPrimary}`,
              neutral0: `${themeColors.colorBackground}`,
              neutral80: `${themeColors.colorText}`,
            },
          })}
          isDisabled={disable}
          isMulti={multi}
          styles={{ menu: base => ({ ...base, zIndex: 9999 }) }}
        />
      </div>
    </Fragment>
  );
}

FilterSelect.defaultProps = {
  disable: false,
  multi: false,
  label: '',
  selectClass: 'topbar__dynamicDropdownWidth',
};

const optionShape = {
  label: PropTypes.string,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  sortName: PropTypes.string,
};

FilterSelect.propTypes = {
  onChange: PropTypes.func.isRequired,
  label: PropTypes.oneOfType([
    PropTypes.shape(),
    PropTypes.string,
  ]),
  selectClass: PropTypes.string,
  name: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape(optionShape)).isRequired,
  selected: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.shape(optionShape)),
    PropTypes.shape(optionShape),
  ]).isRequired,
  disable: PropTypes.bool,
  multi: PropTypes.bool,
};
